export { OneColumnBlock } from './OneColumnBlock';
export type { Props as OneColumnBlockProps } from './OneColumnBlock';
